export default {
    WARNING_DUPLICATE: 'Duplicate item key found in store: ',
    INVALID_STORE: 'Tried to parse a non-existent store.',
    INVALID_STORE_REFRESH: 'Tried to refresh invalid store: ',
    INVALID_ITEM_SELECTION: 'Invalid item selection.',
    PURCHASE_INVALID_STORE: 'tried purchasing an item that does not exist store: ',
    SELL_INVALID_ITEM: 'tried selling an invalid item.',
    ITEM_OUT_OF_STOCK: 'This item is currently out of stock.',
    NOT_ENOUGH_CURRENCY: 'You do not have enough currency to buy this item.',
    NOT_ENOUGH_SPACE: 'You do not have enough space in your inventory.',
    CANNOT_SELL_ITEM: 'You cannot sell this item.',
    ACTION_STORE_NOT_OPEN: 'Tried to perform an action on a store that is not open.',
    CHEATER: 'You have been flagged for cheating. You cannot purchase anything.',
    RESTRICTED_STORE: 'This store does not accept any items.',
    RESTRICTED_ITEM: 'This item cannot be sold here.',
    INVALID_ITEM_COUNT: 'You have entered an invalid amount of items.',
    HOLLOW_ADMIN: 'As an admin you cannot interact with the economy.'
} as const;
